// extracted by mini-css-extract-plugin
export default {"total-prices-container":"Ofwjj","totalPricesContainer":"Ofwjj","price-container":"_F3iQ","priceContainer":"_F3iQ","price-text":"ufV5R","priceText":"ufV5R","price":"h5RCm"};